var _defs, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPicture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaeaea;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.85,170.37H94.22a5.91,5.91,0,0,1-5.89-5.89v-35.2a5.91,5.91,0,0,1,5.89-5.89h12.43l6.89-6.89h0a5.86,5.86,0,0,1,4.31-1.87h14.66a5.6,5.6,0,0,1,4.09,1.72h0l7,7h12.14a5.92,5.92,0,0,1,5.89,5.89v35.2a5.76,5.76,0,0,1-5.82,5.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125,162.61a17.16,17.16,0,0,1-17.17-17.16c.91-22.78,33.44-22.77,34.34,0A17.16,17.16,0,0,1,125,162.61Zm0-31.75a14.59,14.59,0,0,0-14.58,14.59c.76,19.33,28.41,19.32,29.16,0A14.59,14.59,0,0,0,125,130.86Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.11,
    cy: 130.87,
    r: 3.28
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPicture);
export default __webpack_public_path__ + "static/media/no_picture.23e63ed3abb7680220933d5c4b812414.svg";
export { ForwardRef as ReactComponent };